import {StartChildcareFlow} from '../flow'

export const Confirm = () => <StartChildcareFlow />
